var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSdcard48Line = function SvgIconSdcard48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4 39.7H16.6a5.31 5.31 0 0 1-5.3-5.3V18c0-.45.18-.88.5-1.2l8-8c.32-.32.75-.5 1.2-.5h10.4c2.92 0 5.3 2.38 5.3 5.3v20.8c0 2.92-2.38 5.3-5.3 5.3Zm-16.7-21v15.7c0 1.05.85 1.9 1.9 1.9h14.8a1.9 1.9 0 0 0 1.9-1.9V13.6a1.9 1.9 0 0 0-1.9-1.9h-9.7l-7 7Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1 15h-3.4v6h3.4v-6ZM25.1 15h-3.4v6h3.4v-6Z",
    fill: "current"
  })));
};
export default SvgIconSdcard48Line;